import {Injectable} from '@angular/core';
import {Action, Selector, State, StateContext} from '@ngxs/store';
import {firstValueFrom} from 'rxjs';
import {environment} from '../../../environments/environment';
import {BaseService, DataBaseServiceResponse} from '../../services/base-service/base.service';
import {IRecordEnvironmentAffectivity} from './record-environment-affectivity.interface';

export interface IRRecordEnvironmentAffectivity {
  recordEnvironmentAffectivity: IRecordEnvironmentAffectivity;
  wasDeployed?: boolean;
}

export namespace RecordEnvironmentAffectivityAction {
  export class GetActive {
    static readonly type = '[Record] Get Record Environment Affectivity Action';
    constructor(public serviceId: string, public patientId: string) { }
  }

  export class PatchActive {
    static readonly type = '[Record] Patch Record Environment Affectivity Action';
    constructor(public serviceId: string, public patientId: string, public environmentAffectivity: IRecordEnvironmentAffectivity) { }
  }

  export class Deploy {
    static readonly type = '[Record] Was Deployed Environment Affectivity Action';
    constructor(public value: boolean) { }
  }
}

@State<IRRecordEnvironmentAffectivity>({
  name: 'RecordEnvironmentAffectivityState',
  defaults: {
    recordEnvironmentAffectivity: null
  },
})

@Injectable()
export class RecordEnvironmentAffectivityState {
  constructor(
    private baseService: BaseService<any>,
  ) {
  }
  url = environment.SERVER_URL;

  @Selector()
  public static getRecordEnvironmentAffectivity(state: IRRecordEnvironmentAffectivity): IRecordEnvironmentAffectivity {
    return state.recordEnvironmentAffectivity;
  }

  @Selector()
  public static getWasDeployed(state: IRRecordEnvironmentAffectivity): boolean {
    return state.wasDeployed;
  }

  @Action(RecordEnvironmentAffectivityAction.GetActive)
  async getRecordEnvironmentAffectivityAction(
    ctx: StateContext<IRRecordEnvironmentAffectivity>,
    action: RecordEnvironmentAffectivityAction.GetActive
  ): Promise<void> {
    const response: DataBaseServiceResponse<IRecordEnvironmentAffectivity> = await firstValueFrom(
      this.baseService.get(`${this.url}/patients/${action.patientId}/service/${action.serviceId}/records/environment-affectivity/active`)
    );

    if (response.error) throw new Error(response.message);

    ctx.patchState({
      recordEnvironmentAffectivity: response.entity
    });
  }

  @Action(RecordEnvironmentAffectivityAction.PatchActive)
  async patchRecordEnvironmentAffectivityAction(
    ctx: StateContext<IRRecordEnvironmentAffectivity>,
    action: RecordEnvironmentAffectivityAction.PatchActive
  ): Promise<void> {
    const response: DataBaseServiceResponse<void> = await firstValueFrom(
      this.baseService.patch(
        `${this.url}/patients/${action.patientId}/service/${action.serviceId}/records/environment-affectivity`,
        action.environmentAffectivity
      )
    );

    if (response.error) throw new Error(response.message);
  }

  @Action(RecordEnvironmentAffectivityAction.Deploy)
  async wasDeployedRecordEnvironmentAffectivityAction(
    ctx: StateContext<IRRecordEnvironmentAffectivity>,
    action: RecordEnvironmentAffectivityAction.Deploy
  ): Promise<void> {
    ctx.patchState({
      wasDeployed: action.value
    });
  }

}
